import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";

export const money = (value) => Number(value || 0).toFixed(2);
export const niceDate = (value) => (value ? new Date(value).toLocaleDateString() : "-");
export const niceDateTime = (value) => (value ? new Date(value).toLocaleString() : "-");

export function useStudentPortal(endpoint) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(endpoint);
      setData(response.data || {});
    } catch (error) {
      console.error(error);
      toast.error("Failed to load student portal information.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [endpoint]);

  return { data, loading, reload: load };
}

export function PortalLoading({ label = "Loading student portal..." }) {
  return (
    <div className="d-flex align-items-center justify-content-center py-5 gap-2">
      <span className="spinner-border text-success"></span>
      <span className="fw-semibold text-muted">{label}</span>
    </div>
  );
}

export function StudentPageHeader({ title, subtitle, icon = "bi-mortarboard", actions }) {
  return (
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-body d-flex flex-wrap justify-content-between align-items-center gap-3">
        <div className="d-flex align-items-center gap-3">
          <div className="rounded-4 text-white d-flex align-items-center justify-content-center" style={{ width: 54, height: 54, background: "#125b2d" }}>
            <i className={`bi ${icon} fs-3`}></i>
          </div>
          <div>
            <h4 className="fw-bold mb-1" style={{ color: "#125b2d" }}>{title}</h4>
            <p className="text-muted mb-0">{subtitle}</p>
          </div>
        </div>
        <div className="d-flex flex-wrap gap-2">{actions}</div>
      </div>
    </div>
  );
}

export function EmptyState({ icon = "bi-inbox", title = "No records found", message = "Nothing to show yet." }) {
  return (
    <div className="text-center text-muted py-4">
      <i className={`bi ${icon} fs-1 d-block mb-2`}></i>
      <div className="fw-bold">{title}</div>
      <small>{message}</small>
    </div>
  );
}

export function StatusBadge({ value }) {
  const status = String(value || "").toUpperCase();
  const tone =
    status.includes("PAID") || status.includes("CLEAR") || status.includes("ACTIVE") || status.includes("PUBLISHED") || status.includes("VERIFIED") || status.includes("COMPETENT") || status.includes("ADVANCED")
      ? "success"
      : status.includes("ARREARS") || status.includes("OVERDUE") || status.includes("URGENT") || status.includes("SERIOUS") || status.includes("HIGH")
      ? "danger"
      : status.includes("PARTIAL") || status.includes("PENDING") || status.includes("DEVELOPING") || status.includes("DUE")
      ? "warning"
      : "secondary";
  return <span className={`badge text-bg-${tone}`}>{value || "-"}</span>;
}

export function PortalCard({ title, icon, children, footer, to }) {
  return (
    <div className="card border-0 shadow-sm h-100">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="fw-bold mb-0"><i className={`bi ${icon || "bi-grid"} me-2 text-success`}></i>{title}</h6>
          {to && <Link to={to} className="btn btn-sm btn-light border">Open</Link>}
        </div>
        {children}
      </div>
      {footer && <div className="card-footer bg-white border-0 pt-0">{footer}</div>}
    </div>
  );
}
